// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import myAccountFilterSectionStyles from "@sc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    ...myAccountFilterSectionStyles.orderTotalAmountTextField,
};

savedOrderListFilterStyles.fromDate = {
    ...myAccountFilterSectionStyles.fromDate,
};

savedOrderListFilterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

savedOrderListFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

savedOrderListFilterStyles.datesGridItem = {
    width: [12, 12, 12, 4, 4],
};

savedOrderListFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

savedOrderListFilterStyles.toDate = {
    ...myAccountFilterSectionStyles.toDate,
};

savedOrderListFilterStyles.datesContainer = {
    gap: 20,
};

savedOrderListFilterStyles.dateRangeFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
    `,
};

savedOrderListFilterStyles.fromGridItem = {
    width: 6,
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

savedOrderListFilterStyles.toGridItem = {
    width: 6,
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

savedOrderListFilterStyles.buttonsItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        align-items: flex-end;
        justify-content: flex-end;
    `,
};

savedOrderListFilterStyles.orderTotalGridItem = {
    width: [12, 12, 12, 4, 4],
};

savedOrderListFilterStyles.orderTotalContainer = {
    gap: 20,
};

savedOrderListFilterStyles.orderTotalFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
    `,
};

savedOrderListFilterStyles.orderTotalOperatorGridItem = {
    width: [12, 12, 12, 6, 6],
};

savedOrderListFilterStyles.orderTotalAmountGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};
